module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10tqPuF/tc-custom/9781534324473.jpg?1705952115253",
      "alt": "This image is the cover for the book Nita Hawes’ Nightmare Blog Vol. 1: The Fire Next Time, Nita Hawes' Nightmare Blog"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nita Hawes’ Nightmare Blog Vol. 1: The Fire Next Time, Nita Hawes' Nightmare Blog\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From the universe of Eisner-nominated series KILLADELPHIA comes a terrifying new tie-in horror series by acclaimed Marvel writer RODNEY BARNES and fan-favorite SPAWN artist JASON SHAWN ALEXANDER. Untold evil lurks the streets of Baltimore as the demon Corson surfaces from the underworld to possess a man once wronged…and his vengeance will come at humanity’s despair! As gods and demons clash, humanity’s fate hangs in the balance! But paranormal investigator Nita Hawes—a woman with plenty of demons of her own—has set out on a quest to root out the evil from her city. Guided by the ghost of her dead brother, she must come to terms with her own past, lest she become a victim herself and join her brother in a state worse than death! Collects NITA HAWES’ NIGHTMARE BLOG #1-6")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Szymon Kudranski, Syzmon Kudranski, Well-Bee, J Patric Reynolds, Jason Shawn Alexander\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Image Comics\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0